import { getFormsHaveRequiredValues } from "utils";
import { selectCustomisations } from "store/app";

export default function selectHasAllRequiredValues(state) {
  const { userChoiceValues, customisationsVisited } = state.app;

  const customisations = selectCustomisations(state);

  return (customisations || [])
    .map((customisation) =>
      getFormsHaveRequiredValues({
        customisation,
        customisationsVisited,
        userChoiceValues,
      })
    )
    .every(Boolean);
}
